import { NextSeo } from 'next-seo';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { urlHostResolver } from '@/src/lib/utils';
import SecurityView from '@/src/views/root/SecurityView';

export default function PrivacyPage() {
  return (
    <AssembleLayout Layout={MainLayout} Component={SecurityView}>
      <NextSeo
        title="Segurança e privacidade"
        description="Em respeito aos nossos usuários e parceiros, dedicamos um trabalho com as melhores práticas e tecnologias para garantir toda a sua segurança e privacidade."
        openGraph={{
          title: 'Segurança e privacidade',
          url: urlHostResolver('/security'),
        }}
      />
    </AssembleLayout>
  );
}
